import type { UserAuthorizationType } from '@next-space/fe-api-idl';
import { CaptchaSendType } from '@next-space/fe-api-idl';
import type { FC } from 'react';
import { appI18n } from '@flowus/common/i18n';
import { useLogin } from '../../hook/use-login';
import { loginInjector } from '../../utils/init';
import { Input } from '../../uikit/web/input';
import { CaptchaComp } from '../../uikit/web/captcha';
import { Button } from '../../uikit/web/button';

interface ChangeBindPhoneProps {
  onSuccess?: () => void;
  authorizationCode: string;
  userId: string;
  type: UserAuthorizationType;
  isEmail?: boolean;
}
export const ChangeBindPhone: FC<ChangeBindPhoneProps> = (props) => {
  const { isEmail, onSuccess, authorizationCode, userId, type } = props;
  const {
    account,
    accountError,
    setVerifyCodeError,
    setAccount,
    verifyCode,
    verifyCodeError,
    setVerifyCode,
    sendVerifyCode,
  } = useLogin();

  const bindNewPhone = () => {
    (isEmail
      ? loginInjector.request.infra.changeBindEmail.raw(userId, {
          email: account,
          captcha: verifyCode,
          type,
          code: authorizationCode,
        })
      : loginInjector.request.infra.changeBindPhone.raw(userId, {
          phone: account,
          captcha: verifyCode,
          type,
          code: authorizationCode,
        })
    ).then((res) => {
      if (res.code === 200) {
        onSuccess?.();
      } else {
        setVerifyCodeError(res.msg);
      }
    });
  };

  return (
    <div className="next-modal pt-10 pb-5 px-7 flex flex-col items-center min-w-[400px]">
      <div className="mb-5 text-t1-medium">
        {isEmail ? appI18n.t('pkg_login.change_email') : appI18n.t('pkg_login.change_phone')}
      </div>
      <Input
        autoFocus
        warning={accountError}
        value={account}
        className={'w-full mb-5 px-3'}
        inputClassName="h-8"
        onChange={(v) => setAccount(v.toString())}
      />
      <Input
        type="number"
        className={'w-full mb-8 px-3'}
        inputClassName="h-8"
        maxLength={6}
        value={verifyCode}
        warning={verifyCodeError}
        onChange={(v) => setVerifyCode(v.toString())}
        addonAfter={
          <CaptchaComp
            showIcon={false}
            onSendVerifyCode={() => {
              return sendVerifyCode(CaptchaSendType.CHANGE_BIND);
            }}
          />
        }
      />
      <Button
        className="self-start px-5"
        colorType="active"
        disable={!account || !verifyCode}
        onClick={() => bindNewPhone()}
      >
        {appI18n.t('pkg_login.complete_binding')}
      </Button>
    </div>
  );
};
